var React = require('react');

function BlueSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.4521 0.5L39.976 20.0239L20.4521 39.5477L0.928223 20.0239L20.4521 0.5Z","fill":"#4160FA","key":0}),React.createElement("path",{"d":"M33.2624 13.3102L39.976 20.0239L20.4522 39.5477L13.7385 32.8341L33.2624 13.3102Z","fill":"#3555EF","key":1})]);
}

BlueSquare.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = BlueSquare;

BlueSquare.default = BlueSquare;
